import React from 'react';
import {
    Skeleton as MaestroSkeleton,
    Group,
    useBreakpoint,
} from '@landr/maestro';
import { usePromotionalCardsRepeaterQuery } from 'apollo/promotionalCardsRepeater';
import { PromotionalCard as PromotionalCardType } from 'types/generated/graphql';
import { useMilestonesController } from 'controllers/business/Milestones/Milestones.controller';
import { getIsDAWPlugin } from 'helpers';
import { PromotionalCard } from '../PromotionalCard';
import { filterCards } from './PromotionalCardsRepeater.helpers';

const Skeleton: React.FC = () => {
    return (
        <Group.Item width="100%">
            <MaestroSkeleton
                data-testid="whats-new-card-skeleton"
                width="100%"
                height="300px"
                mb="md"
            />
        </Group.Item>
    );
};

export interface PromotionalCardsInnerProps {
    isMobile: boolean;
    isTablet: boolean;
    loading: boolean;
    cards?: PromotionalCardType[];
}

export const _PromotionalCardsRepeater: React.FC<
    PromotionalCardsInnerProps
> = ({ isMobile, isTablet, loading, cards = [] }) => {
    if (!loading && !cards.length) {
        return null;
    }

    const firstCard = cards[0];
    const secondCard = cards[1];

    const showFirstCard = !loading && firstCard;
    const showSecondCard = !loading && !isTablet && secondCard;

    return (
        <Group
            direction={isMobile ? 'vertical' : 'horizontal'}
            gutter={isMobile ? undefined : 'jb'}
        >
            {loading && (
                <>
                    <Skeleton />
                    {!isTablet && <Skeleton />}
                </>
            )}
            {showFirstCard && (
                <Group.Item width="100%" key={`first-card-${firstCard.id}`}>
                    <PromotionalCard {...firstCard} />
                </Group.Item>
            )}

            {showSecondCard && (
                <Group.Item width="100%" key={`second-card-${secondCard.id}`}>
                    <PromotionalCard {...secondCard} />
                </Group.Item>
            )}
        </Group>
    );
};

export interface PromotionalCardsProps {}

export const PromotionalCardsRepeater: React.FC<PromotionalCardsProps> = () => {
    const isMobile = useBreakpoint('md');
    const isTablet = useBreakpoint('lg');
    const isDAWPlugin = getIsDAWPlugin();

    const { data, loading } = usePromotionalCardsRepeaterQuery();

    const { get, isReady } = useMilestonesController();

    const cards = filterCards({
        cards: data?.promotionalCardsRepeater,
        get,
        isDAWPlugin,
        isTablet,
    });

    return (
        <_PromotionalCardsRepeater
            isMobile={isMobile}
            isTablet={isTablet}
            loading={loading || !isReady}
            cards={cards}
        />
    );
};
